
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.767 9.199h.854l2.434-2.434.12-1.033a10.94 10.94 0 00-17.798 5.337c.272-.11.572-.129.854-.051l4.868-.803s.248-.41.376-.384a6.072 6.072 0 018.31-.632h-.018z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M24.523 11.07a10.965 10.965 0 00-3.305-5.33l-3.416 3.416a6.072 6.072 0 012.229 4.817v.606a3.042 3.042 0 012.808 4.204 3.04 3.04 0 01-2.808 1.877h-6.08l-.607.615v3.646l.606.607h6.08a7.907 7.907 0 004.492-14.459z","fill":"#545C69"}}),_c('path',{attrs:{"d":"M7.861 25.493h6.08v-4.868h-6.08c-.433 0-.861-.093-1.255-.273l-.854.265L3.3 23.05l-.214.854a7.866 7.866 0 004.774 1.588z","fill":"#748190"}}),_c('path',{attrs:{"d":"M7.86 9.703a7.908 7.908 0 00-4.773 14.176l3.527-3.527a3.04 3.04 0 114.022-4.022l3.527-3.527a7.9 7.9 0 00-6.302-3.1z","fill":"#fff"}})])
          )
        }
      }
    